/**
 * The controls the task page's `a`, `s` and `t` press (#41), named by id.
 *
 * A key used to find its button by the words on it, which any other button with the
 * same words, or a relabel, would break. The id is set on the one control each key
 * means and read here, so the two cannot drift apart.
 */
export const KEY_TARGET = {
  assign: 'task-key-assign',
  start: 'task-key-start',
  log: 'task-key-log',
} as const
